import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import NavigateToggle from '../navigate-toggle/navigate-toggle';

import './drawer-toggle.less';

const DrawerToggle = ({
  isExpanded,
  onClick,
  openText,
  closedText,
  appearance,
}) => {
  const expansionClass = isExpanded ? 'show-drawer' : 'hide-drawer';
  const spanText = isExpanded ? openText : closedText;

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <span
      className={classNames([
        expansionClass,
        {
          'toggle-teal': appearance === 'teal',
        },
      ])}
      onClick={onClick}
    >
      <NavigateToggle isUp={isExpanded} />
      <span className="toggle-label">{spanText}</span>
    </span>
  );
};

DrawerToggle.displayName = 'DrawerToggle';

DrawerToggle.propTypes = {
  isExpanded: PropTypes.bool,
  onClick: PropTypes.func,
  openText: PropTypes.string,
  closedText: PropTypes.string,
  appearance: PropTypes.oneOf(['grey', 'teal']),
};

DrawerToggle.defaultProps = {
  appearance: 'grey',
};

export default DrawerToggle;
